import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    applyButton: { borderColor: palette.blue, color: palette.blue },
    closeIcon: { color: palette.error.main },
    filterSelector: {
      '& .MuiOutlinedInput-root': { width: '95%' },
    },
  });
